import { Header as HeaderBase } from '@front10/landing-page-book/dist/components';

import styled from 'styled-components';

import { mobileQuery, largeQuery } from '../utils/breakpoints';

const Header = styled(HeaderBase)`
  ${props => ((props.type === 'h1' || !props.type) ? `
    font-size: 48px;
    font-weight: bold;

    margin-bottom: 24px;

    @media ${mobileQuery} {
      font-size: 32px;
    }

    @media ${largeQuery} {
      font-size: 48px;
    }
  ` : '')};

  ${props => (props.type === 'h2' ? `
    font-size: 42px;

    @media screen and ${mobileQuery} {
      font-size: 32px;
    }

    &.orange {
      font-size: 64px;
      font-weight: 900;

      color: var(--bl-orange);

      @media screen and ${mobileQuery} {
        font-size: 32px;
      }
    }
  ` : '')}

  ${props => (props.type === 'h5' ? `
    font-size: 24px;

    @media screen and ${mobileQuery} {
      font-size: 16px;
    }
  ` : '')}

  /* ${props => ((props.withShadow) ? `
    text-shadow: ${[10, 20, 30].map(n => (`white 0 0 ${n}px`)).join(',')};
  ` : '')} */
`;

export default Header;
